<template>
  <div class="property-tab">
    <div class="property-title">Region Name:</div>
    <v-tooltip location="bottom" :disabled="regionName.length < 1">
      <template #activator="{ props }">
        <v-text-field
          v-model="regionName"
          hide-details
          single-line
          variant="outlined"
          density="compact"
          class="field-bordered"
          v-bind="props"
          :disabled="PreferenceStore.INSTANCE.isReadOnly"
          @focus="onFocus"
          @blur="onBlur"
        ></v-text-field>
      </template>
      <span>{{ regionName }}</span>
    </v-tooltip>
  </div>
</template>

<script setup lang="ts">
import { Region } from "../mvc/region";
import RappidContext from "../rappid/rappid-context";
import { inject, computed, onMounted, onBeforeUnmount } from "vue";
import { PreferenceStore } from "../services/preference-store";

const rappidContext: RappidContext = inject<RappidContext>("rappidContext");

const compProps = defineProps<{
  model: Region;
}>();

const emit = defineEmits(["notifyChange"]);

const changeNotifier = (model) => {
  emit("notifyChange", model);
};

onMounted(() => {
  compProps.model.on("change", changeNotifier, compProps.model);
});

onBeforeUnmount(() => {
  compProps.model.off("change", changeNotifier);
});

function onFocus() {
  rappidContext.commandManager.initBatchCommand();
}

function onBlur() {
  rappidContext.commandManager.storeBatchCommand();
}

const regionName = computed({
  get(): string {
    return compProps.model.getName();
  },
  set(name: string) {
    compProps.model.setName(name);
  },
});
</script>
